/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/promise-function-async */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-curly-brace-presence */

'use client'

import React, { Suspense, useEffect, useState } from 'react'
import Image from 'next/image'
import GlobalHeader from '@components/GlobalHeader'
import { useUserContext } from '@context/UserContext/UserContenxt'
import { getPageType } from 'src/helpers/commonHelpers'
import { useUserData } from '@utils/userUserData'
import { HEADER_THEME } from '@styles/theme'
import { Lob } from '@enums/Lob'
import Cookies from 'js-cookie'
import { ACKO_LOGO_HORIZONTAL_GRADIENT_DARK, ACKO_LOGO_HORIZONTAL_GRADIENT_WHITE } from '@components/utils/ackoLogoUrls'
import { isVasWidget } from '@helpers/vasLandingPageHelper'
import Link from 'next/link'
import { BASE_URL } from '@components/MainWidget/common/commonConstants'
import { NEWCAR_SEM_PAGE } from '@configs/components.config'
import styles from './productNav.module.scss'

const lobSemNavBarRequired = {
  [Lob.TRAVEL]: true,
}

const HeaderDesktopAndMweb = ({
  isSemPage = false,
  headerLinks,
  darkDesktop = false,
  darkMobile = false,
  blackVariant = false,
  isWhiteVariant = false,
  logoVideoUrl,
  isHomeWrapper = false,
  theme = HEADER_THEME.LIGHT,
  lob = null,
  loginBaseUrl = '',
  data,
}: {
  isSemPage?: boolean
  headerLinks: any
  darkDesktop?: boolean
  darkMobile?: boolean
  blackVariant?: boolean
  logoVideoUrl?: string
  isHomeWrapper?: boolean
  isWhiteVariant?: boolean
  theme?: HEADER_THEME
  lob?: any
  loginBaseUrl?: string
  data?: any
}) => {
  const content = data?.data?.attributes
  const isVasLandingWidget = isVasWidget(content?.widget)

  const [isLoggedIn, setIsLoggedIn] = useState<boolean | undefined>(undefined)
  const userDataValue = useUserData(isLoggedIn)
  const { setUserLoggedIn } = useUserContext()

  useEffect(() => {
    const isUserLoggedIn = !!Cookies.get('user_id')
    setIsLoggedIn(isUserLoggedIn)
    setUserLoggedIn(isUserLoggedIn || false)
  }, [])

  const renderMinimalNavBar = (isSemPage && lob && lobSemNavBarRequired[lob]) || (isVasLandingWidget && !!isSemPage)

  if (content?.widget === NEWCAR_SEM_PAGE) {
    // the header(acko logo) is in the widget
    return null
  }

  return (
    <Suspense fallback={<div className={styles.loaderStyles} />}>
      {renderMinimalNavBar ? (
        <div className={styles.semNavbar}>
          <Link href={BASE_URL}>
            <Image
              width={100}
              height={24}
              src={
                content?.theme !== 'light' ? ACKO_LOGO_HORIZONTAL_GRADIENT_DARK : ACKO_LOGO_HORIZONTAL_GRADIENT_WHITE
              }
              alt="Acko Company Logo"
              priority
            />
          </Link>
        </div>
      ) : (
        <GlobalHeader
          schema={headerLinks}
          darkDesktop={darkDesktop}
          darkMobile={darkMobile}
          blackVariant={blackVariant}
          isWhiteVariant={isWhiteVariant}
          logoVideoUrl={logoVideoUrl}
          isLoggedIn={isLoggedIn}
          userData={userDataValue}
          largeHeader
          pageType={getPageType(isSemPage)}
          isHomeWrapper={isHomeWrapper}
          theme={theme}
          loginBaseUrl={loginBaseUrl}
        />
      )}
    </Suspense>
  )
}

export default HeaderDesktopAndMweb
